import FeeComp from './feeComp'
import useFooter from 'useFooter';
import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import ReactDOM from 'react-dom';

function Fee() {
  useFooter();

  return (
    <div>
      <FeeComp></FeeComp>
    </div>
  )
}

export default Fee;
